export default function WhyHongKongSection() {
  const advantages = [
    {
      icon: 'ri-global-line',
      title: '國際金融中心',
      description: '全球最自由經濟體，連接內地與國際市場的最佳橋樑'
    },
    {
      icon: 'ri-shield-check-line',
      title: '法治與穩定',
      description: '完善的法律制度，保障個人財產與商業權益'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '低稅率優勢',
      description: '簡單稅制，無資本增值稅、股息稅及遺產稅'
    },
    {
      icon: 'ri-parent-line',
      title: '優質教育',
      description: '世界級教育資源，中西文化融合的成長環境'
    },
    {
      icon: 'ri-plane-line',
      title: '地理優勢',
      description: '亞洲中心位置，4小時內可達主要亞洲城市'
    },
    {
      icon: 'ri-team-line',
      title: '人才政策',
      description: '政府積極「搶人才」，提供多元化入境途徑'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            為什麼選擇香港？
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            香港，這座融合東方傳統與西方制度的國際都會，正以前所未有的開放姿態迎接全球精英。無論您是尋求事業突破的頂尖人才、擁有豐富經驗的專業人士，還是希望進行資產配置的高淨值投資者，香港特區政府的「搶人才」政策都為您提供了黃金窗口期。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((item, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 group"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${item.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{item.title}</h3>
              <p className="text-gray-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            我們深入研究了最新的入境政策，為您整理出以下四大核心移居通道。不確定哪一種適合您？
            <strong className="text-teal-600"> 萬業人才資本 (Omni Workforce) </strong>
            擁有超過十年的人力資源經驗，隨時為您提供專業評估。
          </p>
        </div>
      </div>
    </section>
  );
}
